<template>
  <div class="rating-block" :class="{ open, extreme }">
    <div class="target" @touchend="open = !open">
      <star :fill="rating && rating.relevant" />
      <div class="val" v-if="rating">{{ ratingAvg }}</div>
    </div>
    <div class="dropdown block" :class="{ ended }">
      <RatingLine :name="$t('events.rating.relevant')" v-model="data.relevant" />
      <RatingLine :name="$t('events.rating.informative')" v-model="data.informative" />
      <RatingLine :name="$t('events.rating.interesting')" v-model="data.interesting" />

      <div class="thank" v-if="ended">{{ $t('events.rating.thanks') }}</div>
    </div>
  </div>
</template>

<script>
import Star from '@/components/icons/star'
import RatingLine from '@/components/events/RatingLine'
import _debounce from 'lodash/debounce'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'Rating',
  components: { RatingLine, Star },
  props: {
    id: Number,
    rating: Object,
    extreme: Boolean,
  },
  data: () => ({
    data: {
      relevant: 0,
      informative: 0,
      interesting: 0,
    },
    init: false,
    ended: false,
    timer: false,
    open: false,
  }),
  methods: {
    ...mapMutations('events', ['updateEvent']),
    ...mapActions('events', ['sendRate']),
  },
  computed: {
    ratingAvg() {
      const list = Object.values(this.rating)
      const sum = list.reduce((tmp, el) => tmp + el)
      return (sum / list.length).toFixed(1)
    },
  },
  watch: {
    rating: {
      deep: true,
      immediate: true,
      handler(rating) {
        if (!rating || !Object.keys(rating).length) return
        this.init = true
        Object.keys(this.data).forEach((key) => {
          this.data[key] = rating[key] || 0
        })
      },
    },
    data: {
      deep: true,
      handler: _debounce(function (data) {
        if (Object.values(data).every((val) => val)) {
          this.ended = true
          if (this.timer) clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.open = false
            this.ended = false
          }, 5000)
          this.sendRate({
            params: {
              id: this.id,
            },
            data,
          }).then(({ data: event }) => {
            this.updateEvent(event)
          })
        }
      }, 100),
    },
  },
}
</script>

<style lang="scss">
.rating-block {
  position: relative;
  outline: none !important;

  @mixin open {
    .target {
      filter: brightness(0.9);
    }

    .dropdown {
      display: block;
    }
  }

  &.open {
    @include open;
  }

  @include PC {
    &:hover,
    &:focus,
    &.open {
      @include open;
    }
  }

  > .target {
    @include flexCenter;
    position: relative;
    z-index: 11;
    padding: 5px;
    margin: -5px;
    cursor: pointer;
    transition: all 0.25s;

    .val {
      font-weight: 400;
      font-size: 15px;
      line-height: 125%;
      margin-left: 7px;
    }
  }

  .dropdown {
    position: absolute;
    z-index: 10;
    bottom: 32px;
    left: -24px;
    padding: 17px 24px 20px 21px;
    display: none;

    &.ended .rating-line-block {
      filter: blur(2px);
      opacity: 0.1;
    }

    .thank {
      @include flexCenter;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      //background: rgba($white, 0.95);
      font-weight: bold;
      color: $text;
      border-radius: 5px;
    }

    &::before {
      content: '';
      background: url('~@/assets/icons/arrow-dropdown.svg') no-repeat center top;
      display: block;
      width: 15px;
      height: 8px;
      position: absolute;
      top: 100%;
      left: 25px;
    }

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      height: 30px;
    }
  }

  &.extreme .dropdown {
    left: unset;
    right: -24px;

    &::before {
      left: unset;
      right: 25px;
    }
  }
}
</style>
